// extracted by css-extract-rspack-plugin
export default {"ghost":"src-modules-desktop-pages-MainPage-components-WidgetMarketplace-helpers-createTilePreviewGhost-module__ghost-HBobH7","thumb":"src-modules-desktop-pages-MainPage-components-WidgetMarketplace-helpers-createTilePreviewGhost-module__thumb-X9o1p2","name":"src-modules-desktop-pages-MainPage-components-WidgetMarketplace-helpers-createTilePreviewGhost-module__name-owrWXL"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"ghost\":\"src-modules-desktop-pages-MainPage-components-WidgetMarketplace-helpers-createTilePreviewGhost-module__ghost-HBobH7\",\"thumb\":\"src-modules-desktop-pages-MainPage-components-WidgetMarketplace-helpers-createTilePreviewGhost-module__thumb-X9o1p2\",\"name\":\"src-modules-desktop-pages-MainPage-components-WidgetMarketplace-helpers-createTilePreviewGhost-module__name-owrWXL\"}";
        // 1793875576457
        var cssReload = require("../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  